import CashbackEdit from './CashbackEdit';

export default CashbackEdit;
